module.exports = __webpack_public_path__ + "static/media/Glitch-2.fc636b2c.webp";